import React from "react";

interface SubmitButtonProps {
  isSubmitting: boolean;
  disabled: boolean;
  onClick: () => void;
  primaryColor: string;
  submitText: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting, disabled, onClick, primaryColor, submitText }) => {
  return (
    <button className="submit-button" onClick={onClick} disabled={disabled} style={{ backgroundColor: primaryColor }}>
      {isSubmitting ? <span className="loading-spinner"></span> : submitText}
    </button>
  );
};

export default SubmitButton;
